import { CommonService } from './../services/common.service';
import { AppService } from './../services/app.service';
import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { RedirectRoutes } from '../enums/routes';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private router: Router,
    public appService: AppService,
    private commonService: CommonService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.appService.setConfigProps([]);
    this.commonService.appDashBoardData = [];
    this.commonService.appDashBoardData = [];
    this.commonService.commonDashBoardData = [];
    this.appService.breadCum=[]
    const currentUser = JSON.parse(localStorage.getItem('current_user') as string);
    if (currentUser) {
      if (route.routeConfig && route.routeConfig.path !== RedirectRoutes.CHOOSEORG) {
        // if (currentUser.isSetupCompleted === false) {
        //   this.commonService.timezoneConfirm();
        // }
        // if (!checkTimeZone.orgType && checkTimeZone.accSW=='XER') {
        //   this.commonService.accountantConfirm();
        // }
      }
      if (route.data['roles']) {
        if (route.data['roles']) {
          var res = route.data['roles'].filter(function (v: string) {
            // iterate over the array
            return currentUser.roles.indexOf(v) > -1;
          });
          if (res.length > 0) {
            return true;
          } else {
            this.router.navigate(['unauthorized']);
            return false;
          }
        }
      }
      // authorised so return true
      return true;

    }
    else if (route.routeConfig && route.routeConfig.path == RedirectRoutes.CHOOSEORG) {
      if (this.appService.getToken()) {
        return true;
      }
    }
    // not logged in
    this.router.navigate(['auth/login']);
    return false;
  }


}